import { Button, CardActions, Grid } from "@mui/material";
import { getUserClaims } from "features/application/application-slice";
import { assign_customer_coherent_screen, get_customer_administrator_as_customer, get_customer_coherent_screens, get_customer_curated_media_lists, get_customer_settings_as_admin, get_customer_settings_as_customer, store_coherent_screen_for_customer } from "features/auto-thunks";
import { get_all_customerAdministrator, get_selected_customerAdministrator, is_customerAdministrator_busy } from "features/customerAdministrator/customerAdministrator-slice";
import { get_all_customerSettings, get_selected_customerSettings } from "features/customerSettings/customerSettings-slice";
import { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { gridSpacing } from 'store/constant';
import TitleService from "title-service";
import MainCard from "ui-component/cards/MainCard";
import { get_all_processedMedia } from "features/processedMedia/processedMedia-slice";
import { get_all_curatedMediaList, is_curatedMediaList_busy } from "features/curatedMediaList/curatedMediaList-slice";
import { CoherentScreen, CuratedMediaList } from "models";
import CoherentScreenEditor, { CoherentScreenConfig } from './CoherentScreenEditor';
import RedQuickTextField from "./RedQuickTextField";
import * as SC from 'features/shared_components';
import { get_all_coherentScreen, is_coherentScreen_busy } from "features/coherentScreen/coherentScreen-slice";
import { useTheme } from "@emotion/react";
import LinearIndeterminate from "./LinearIndeterminate";

export default function CustomerAdministratorComponent() {
    const claims = useSelector(getUserClaims);
    const theme = useTheme();
    const curatedMedia_list = useSelector(get_all_curatedMediaList);
    const coherentScreen_list = useSelector(get_all_coherentScreen);
    const customerAdministrators = useSelector(get_all_customerAdministrator)
    const customerSettings = useSelector(get_all_customerSettings);
    const customerAdministrator = customerAdministrators.find(x => x.id === claims?.customerAdministrator)
    const [curatedMediaList, setCuratedMediaList] = useState<CuratedMediaList[]>([]);
    const [currentCuratedMediaList, setCurrentCuratedMediaList] = useState<CuratedMediaList>(null);
    const [defaultCoherentScreen, setDefaultCoherentScreen] = useState(null);
    const [currentScreen, setCurrentScreen] = useState<CoherentScreenConfig>({
        lists: [],
        id: '',
        name: ''
    });
    const customerSetting = customerSettings.find(x => x.id === customerAdministrator?.customerSettingId);
    const coherentScreen_busy = useSelector(is_coherentScreen_busy);
    const curatedMediaList_busy = useSelector(is_curatedMediaList_busy);
    const customerAdministrators_busy = useSelector(is_customerAdministrator_busy);

    const busy = customerAdministrators_busy || curatedMediaList_busy || coherentScreen_busy || false;
    useEffect(() => {
        if (claims?.customerAdministrator) {
            dispatch(get_customer_settings_as_admin({
                customerAdministratorId: claims?.customerAdministrator,
                userId: claims?.user
            }))
        }
    }, [claims?.customerAdministrator]);
    useEffect(() => {
        if (claims?.customerAdministrator) {
            dispatch(get_customer_coherent_screens({
                customerAdministratorId: claims?.customerAdministrator,
                userId: claims?.user
            }))
            dispatch(get_customer_curated_media_lists({
                customerAdministratorId: claims?.customerAdministrator,
                userId: claims?.user
            }))
            dispatch(get_customer_settings_as_customer({
                customerAdministratorId: claims?.customerAdministrator,
                userId: claims?.user
            }))
            dispatch(get_customer_administrator_as_customer({
                customerAdministratorId: claims?.customerAdministrator,
                userId: claims?.user
            }));

        }
    }, [claims?.customerAdministrator])
    useEffect(() => {
        if (curatedMedia_list) {
            let local_list = curatedMedia_list.filter(x => x.owner === customerAdministrator?.customerSettingId);
            setCuratedMediaList(local_list);
            if (!currentCuratedMediaList && local_list[0]) {
                setCurrentCuratedMediaList(local_list[0])
            }
        }
    }, [customerAdministrator && curatedMedia_list?.length])

    return <>
        <Grid container spacing={gridSpacing}>
            <Grid item xs={12}>
                <LinearIndeterminate visible={busy} />
            </Grid>
            <Grid item xs={12} xl={3} md={3}>
                <MainCard title={TitleService('Home Screens')}>
                    <Grid item xs={12} sm={12} md={12} >
                        {SC.sharedList(
                            (coherentScreen_list || [])
                                .filter(x => !x.deleted && x.owner === customerAdministrator?.customerSettingId)
                                .filter(x => !x.orderedReferenceList.some(v => !curatedMedia_list.find(t => t.id === v)))
                                .map(item => {
                                    return {
                                        ...item,
                                    }
                                }),
                            SC.sharedListItemBuilder,
                            (item: CoherentScreen) => {
                                return {
                                    name: item?.name || TitleService('Unknown'),
                                    date: item?.created || item.updated,
                                    selected: item?.id === currentScreen.id,
                                    statusColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light,
                                    getIcon: () => {
                                        return (
                                            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-list-details"
                                                width="20" height="20" viewBox="0 0 24 24"
                                                strokeWidth="1.5" stroke="#597e8d" fill="none"
                                                strokeLinecap="round" strokeLinejoin="round">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                <path d="M13 5h8" />
                                                <path d="M13 9h5" />
                                                <path d="M13 15h8" />
                                                <path d="M13 19h5" />
                                                <rect x="3" y="4" width="6" height="6" rx="1" />
                                                <rect x="3" y="14" width="6" height="6" rx="1" />
                                            </svg>
                                        )
                                    }
                                }
                            }, (item: CoherentScreen) => {
                                let config: CoherentScreenConfig = {
                                    name: item.name,
                                    id: item.id,
                                    lists: (item.curatedMediaLists as any)
                                }
                                setCurrentScreen(config)
                            })}
                    </Grid>
                </MainCard>
            </Grid>
            <Grid item xs={12} xl={9} md={9}>
                <MainCard title={currentScreen?.name || TitleService('Screen')}>
                    <CardActions sx={{ justifyContent: 'flex-end' }}>

                        {currentScreen.id ? <Button disabled={busy} variant="text" color={'secondary'} onClick={async () => {
                            await dispatch(assign_customer_coherent_screen({
                                customerAdministratorId: claims?.customerAdministrator,
                                userId: claims?.user,
                                screenId: currentScreen.id
                            }))
                            await dispatch(get_customer_settings_as_customer({
                                customerAdministratorId: claims?.customerAdministrator,
                                userId: claims?.user,
                            }))
                        }} > {customerSetting?.coherentScreen == currentScreen?.id ? TitleService('Current') : TitleService('Make Home Screen')}</Button> : null}
                        <Button variant="text" disabled={busy} color={'primary'} onClick={async () => {
                            console.log('save')
                            await dispatch(store_coherent_screen_for_customer({
                                customerAdministratorId: claims?.customerAdministrator,
                                userId: claims?.user,
                                config: currentScreen
                            }))
                            await dispatch(get_customer_curated_media_lists({
                                customerAdministratorId: claims?.customerAdministrator,
                                userId: claims?.user,
                            }))
                        }} >{TitleService('Save')}</Button>
                    </CardActions>
                    <div style={{ paddingBottom: 20 }}>
                        <RedQuickTextField title={TitleService('Name')} value={currentScreen?.name} onChange={(val) => {
                            setCurrentScreen({
                                ...currentScreen,
                                name: val
                            })
                        }} />
                    </div>
                    <CoherentScreenEditor onChange={(update) => {
                        setCurrentScreen(update);
                    }} screen={currentScreen} />
                </MainCard>
            </Grid>
            <Grid item xs={12}>
                <LinearIndeterminate visible={busy} />
            </Grid>
        </Grid>
    </>
}